import $ from 'jquery';

$(document).ready(function () {


  checkCookiesWarningVisibility();

  $('.ekomi-widget-close-button').on('click', function (event) {
    event.preventDefault();
    $('.ekomi-widget-warning').addClass('ekomi-widget-warning-hidden');
  });

  if ($(".closecookie").length) {
    $('.closecookie').on('click', function (event) {
      event.preventDefault();
      setEkomiWidgetBottomPosition(false);
    });
  }

  function checkCookiesWarningVisibility() {
    if ($(".not-accepted").length) {
      setEkomiWidgetBottomPosition(true);
    } else {
      setEkomiWidgetBottomPosition(false);
    }
  }

  function setEkomiWidgetBottomPosition(isCookiesWarningVisible) {
    if (isCookiesWarningVisible) {
      $('.ekomi-widget-warning').css("bottom", "200px");
    } else {
      $('.ekomi-widget-warning').css("bottom", "20px");
    }
  }


  


  

});



// WEBPACK FOOTER //
// ./app/ui/elements/ekomi-widget-warning/index.js